import { render, staticRenderFns } from "./OrganizationSettingsGeneral.vue?vue&type=template&id=48814ef4&scoped=true"
import script from "./OrganizationSettingsGeneral.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsGeneral.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsGeneral.vue?vue&type=style&index=0&id=48814ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48814ef4",
  null
  
)

export default component.exports